module.exports = __webpack_public_path__ + "img/showcase-dashboard.d7d78fbd.png";